import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { ApplicationUrlSettings } from '../../settings/ApplicationUrlSettings';

@Injectable()
export class CacheService {

  constructor(private http: Http) {

  }

  getDirectionsRoute(request) {
    let url = `${ApplicationUrlSettings.NODE_API_URL}cache/directions-route`;
    return this.http.post(url, request).toPromise().then(res => res.json())
  }

  saveDirectionsRoute(request,response){
    let url = `${ApplicationUrlSettings.NODE_API_URL}cache/directions-route`;
    var payload = {
      request:request,
      response:response
    }
    return this.http.patch(url, payload, request).toPromise().then(res => res.json())
  }
}
